export default __webpack_public_path__ + "static/media/icon-ready-for-driver.da5c2b77.svg";